import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { Subject, Subscription } from "rxjs";
// @ts-ignore
import { ConfigService } from "@services/config/config.service";
import packageJson from '../../../../package.json';

@Injectable({
    providedIn: 'root'
})
export class eVersionService
{
    public updateAvailable: Subject<string> = new Subject();

    constructor(
        private swUpdate: SwUpdate,
        private configService: ConfigService
    )
    {

    }

    private availableSubscrition: Subscription;

    ngOnDestroy()
    {
        this.availableSubscrition?.unsubscribe();
    }

    private async OnUpdateAvailable()
    {
        let config = await this.configService.get();

        if (config.version === packageJson.version)
        {
            return;
        }

        this.updateAvailable.next(config.version);
    }

    public async Update(): Promise<void>
    {
        await this.swUpdate.activateUpdate();
    }

    public CheckUpdate()
    {
        this.availableSubscrition = this.swUpdate.versionUpdates.subscribe(
            (event) =>
            {
                if (event.type === 'VERSION_DETECTED')
                {
                    this.OnUpdateAvailable.bind(this);
                }
            }
        );

        if (this.swUpdate.isEnabled)
        {
            this.swUpdate.checkForUpdate();
        }
    }
}
